//@ts-nocheck

import React from 'react'

import { Blog } from '../BlogTemplates'

const ErrorMessage = () => (
  <p>
    Error - please check the number of groups. Accepted count is 1, 2, 3, or 5!
  </p>
)

const VARIANTS = {
  LARGE: 'Large',
  SMALL: 'Small',
  SLIM: 'Slim',
}

const GetAuthor = (displayAuthorName, inheritedShowAuthorName, authorName) => {
  if (!displayAuthorName || !inheritedShowAuthorName || !authorName) return

  return authorName
}

const GetAuthorURL = (displayAuthorName, linkToBio, authorUrl) => {
  if (!displayAuthorName || !linkToBio) return
  return '/author-bio/' + authorUrl
}

const BlogPreview = ({ moduleData }) => {
  const getBlogComponent = (count) => {
    switch (count) {
      case 1:
        return Blog.Preview.Single
      case 2:
        return Blog.Preview.Double
      case 3:
        return Blog.Preview.Triple
      case 5:
        return Blog.Preview.Slim
      default:
        return ErrorMessage
    }
  }

  const getVariant = (count) => {
    if (count === 1) {
      return VARIANTS.LARGE
    } else if (count === 2) {
      return VARIANTS.SMALL
    }

    return VARIANTS.SLIM
  }

  const getUrl = ({ blogCategory, blogPost }) => {
    let url = `/${blogCategory}/${blogPost}`

    // Adds a trailing slash to prevent an additional redirect
    if (!url.endsWith('/')) {
      url += '/'
    }

    return url
  }

  const getBlogProps = (groups) => {
    const blogProps = {}

    // Params should not end with `1` if there is only one group
    const singleGroup = groups.length === 1

    for (let i = 0; i < groups.length; i++) {
      const num = singleGroup ? '' : i + 1

      blogProps[`imagePublicId${num}`] = groups[i].image
      blogProps[`imageAlt${num}`] = groups[i].imageAlt
      blogProps[`blogUrl${num}`] = getUrl(groups[i])
    }

    return blogProps
  }

  const getBlogCopy = ({
    eyebrow,
    heading,
    subHeading,
    blogPublishDate,
    displayAuthorName,
    linkToBio,
    showLearnMore,
    inheritedDisplayAuthor,
    authorName,
    authorUrl,
  } = {}) => {
    return {
      eyebrow,
      headline: heading,
      previewBody: subHeading,
      authorName: GetAuthor(
        displayAuthorName,
        inheritedDisplayAuthor,
        authorName
      ),
      authorURL: GetAuthorURL(displayAuthorName, linkToBio, authorUrl),
      date: new Date(blogPublishDate),
      showLearnMore: showLearnMore ?? false,
    }
  }

  const getBlogCopyProps = (groups) => {
    const variant = getVariant(groups.length)

    if (groups.length === 1) {
      return { variant, ...getBlogCopy(groups[0]) }
    } else {
      const blogProps = {}

      for (let i = 0; i < groups.length; i++) {
        blogProps[`copyProps${i + 1}`] = {
          variant,
          blogUrl: getUrl(groups[i]),
          ...getBlogCopy(groups[i]),
        }
      }

      return blogProps
    }
  }

  const getBlogPreviewArticles = (groups) => {
    return groups.map((group) => ({
      ...getBlogCopy(group),
      imageAlt: group.imageAlt,
      imagePublicId: group.image,
      blogUrl: getUrl(group),
      variant: VARIANTS.SLIM,
    }))
  }

  const { heading, displayHeading, showRoundedCorners, groups } = moduleData

  const BlogComponent = getBlogComponent(groups.length)

  if (groups.length <= 3) {
    const blogProps = getBlogProps(groups)
    const blogCopyProps = getBlogCopyProps(groups)

    return (
      <BlogComponent
        {...blogProps}
        {...blogCopyProps}
        heading={heading}
        displayHeading={displayHeading}
        showRoundedCorners={showRoundedCorners}
      />
    )
  } else if (groups.length === 5) {
    return (
      <BlogComponent
        heading={heading}
        displayHeading={displayHeading}
        articles={getBlogPreviewArticles(groups)}
      />
    )
  } else {
    // Count must be at least 1, 2, 3, or 5
    return <ErrorMessage />
  }
}

export default BlogPreview
